import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { AppointmentServiceInternal } from "../../services/appointment.service";
import cofirmappointmentlogo from "../../assets/images/ConfmAppointment-logo.png";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import FullPageLoader from "../Shared/FullPageLoader";
import { toast } from "react-toastify";
import { BUTTONS } from '../../constants';
import userStore from '../../store/store';
import { PatientInfoResponse } from '../../models/patientInfoDtos';


interface ConfirmApplicationProps {
  changeStep: (data: any) => void;
  formData: any;
  primaryProviderMessage: string;
  convertedTime: string;
  isReschedule: boolean;
  currentAppointment: any;
  updateFormData: (data: any) => void;
}

const ConfirmAppointmentForm: React.FC<ConfirmApplicationProps> = (props) => {
  const { formData } = props;
  const user: any = userStore();
  const [isLoading, setIsLoading] = useState(false);
  const [isVerifyInmateOpen, setIsVerifyInmateOpen] = useState(props.formData.patientMatches.length > 0);
  const [isPatientMatches] = useState(props.formData.patientMatches.length > 0);
  const [selectedPatientId, setSelectedPatientId] = useState("0");
  const [selectedPatient, setSelectedPatient] = useState<PatientInfoResponse | null>(null);

  const formatDate = (inputDate: string | number | Date) => {
    const dateObject = new Date(inputDate);
    return dateObject.toLocaleDateString('en-US', { weekday: 'long', month: 'numeric', day: 'numeric', year: 'numeric' });
  };

  const formatYmd = (ymd: string) => {
    const [year, month, day] = ymd.split("-");
    return `${month}/${day}/${year}`;
  };

  // Inclusive calendar days from incarceration date through the appointment date.
  const daysIncarcerated = (() => {
    if (!formData.incarceration_date || !formData.appointmentDate) return null;
    const [y, m, d] = formData.incarceration_date.split("-").map(Number);
    const start = new Date(y, m - 1, d);
    const appt = new Date(formData.appointmentDate);
    const apptDay = new Date(appt.getFullYear(), appt.getMonth(), appt.getDate());
    const days = Math.round((apptDay.getTime() - start.getTime()) / 86400000) + 1;
    return days >= 1 ? days : null;
  })();

  const onSelectPatient = (event: React.ChangeEvent<HTMLInputElement>) => {
    let patientId = event.target.value;
    console.log(patientId);
    setSelectedPatientId(patientId);
    console.log(props.formData.patientMatches.find((p: PatientInfoResponse) => p.localPatientId === patientId));
    setSelectedPatient(props.formData.patientMatches.find((p: PatientInfoResponse) => p.localPatientId === patientId));
  }

  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    setIsLoading(true);
    event.preventDefault();
    const postData = {
      appointmentid: props?.currentAppointment?.appointmentid ?? 0,
      appointmenttypeid: Number(formData.appointmenttypeid),
      providerId: Number(formData.providerId),
      appointmentdatetime: formData.appointmentDate.toISOString(),
      appointmentDate: formData.appointmentDate.toLocaleString('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }),
      appointmentTime: formData.appointmentTime,
      inmatename: props?.currentAppointment?.inmatename ?? formData.inmatename,
      inmatedob: props?.currentAppointment?.inmatedob ?? new Date(selectedPatient?.dob ?? formData.inmatedob),
      heldforanothercounty: formData.heldforanothercounty,
      countyid: Number(formData.countyid),
      countyname: formData.countyname,
      admincountyid: Number(formData.admincountyid),
      additionalinfo: props?.currentAppointment?.additionalinfo ?? formData.additionalinfo,
      medications: props?.currentAppointment?.medications ?? formData.medications,
      providerName: formData.providername,
      ZipCode: props?.currentAppointment?.zipCode ?? (selectedPatient?.zip ?? formData.zipCode),
      athenaAppointmentId: formData.athenaAppointmentId,
      athenaPatientId: props?.currentAppointment?.athenaPatientId ?? Number(props.formData.athenaPatientId !== 0 ? props.formData.athenaPatientId : selectedPatientId),
      hasAthenaAssessment: props?.currentAppointment?.hasAthenaAssessment ?? false,
      inmateFirstName: props?.currentAppointment?.inmateFirstName ?? (selectedPatient?.firstName ?? formData.inmateFirstName),
      inmateLastName: props?.currentAppointment?.inmateLastName ?? (selectedPatient?.lastName ?? formData.inmateLastName),
      facilityName: formData.facilityName,
      correctionalFacilityId: formData.correctionalFacilityId,
      incarceration_date: formData.incarceration_date ? formData.incarceration_date : null,
      anticipated_release_date: formData.anticipated_release_date ? formData.anticipated_release_date : null
    };

    try {    
      const response = props?.isReschedule ?
      await AppointmentServiceInternal.rescheduleappointment(props?.currentAppointment.appointmentid, postData) :
      await AppointmentServiceInternal.saveappointment(postData);
      if (response?.data.isSuccess) {
        const userRoleId = user.getUser().id_role;
        window.location.href = userRoleId === 2 ? "/facility-dashboard" : "/itp-dashboard";
      }
      else {
        setIsLoading(false);
        toast.error(response?.data.message);
      }
    }
    catch (error: any) {
      setIsLoading(false);
      toast.error("Error confirming appointment: " + error.response.data.message);
    }
  };

  const handlePrevious = () => {
    props.updateFormData({
      ...props.formData,
      appointmentTime: "",
      appointmentDate: "",
      appointmentDateTime: "",
      athenaAppointmentId: 0
    });
    props.changeStep(-1);
  }

  return (
    <>
      {isLoading && <FullPageLoader />}
      <Dialog fullWidth maxWidth="md" open={isVerifyInmateOpen} onClose={() => setIsVerifyInmateOpen(false)}>
        <DialogTitle>
          Verify Inmate Information
        </DialogTitle>
        <DialogContent sx={{ px: 4 }}>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup value={selectedPatientId} onChange={onSelectPatient}>
              <Box display="flex" gap={6} mx="auto">
                <Box display="flex" flexDirection="column">
                  <Typography variant="body1" gutterBottom>
                    Use Information Provided {"(Create New Inmate)"}
                  </Typography>
                  <FormControlLabel
                    value={"0"}
                    control={<Radio />}
                    sx={{
                      p: "5px",
                      my: "5px",
                      border: 1,
                      borderRadius: 2,
                      borderColor: selectedPatientId === "0" ? 'primary.main' : 'transparent',
                      transition: 'border-color 0.3s ease',
                      '&:hover': {
                        borderColor: selectedPatientId === "0" ? 'primary.main' : 'gray',
                      },
                    }}
                    label={
                      <>
                        <Typography variant="subtitle2">
                          {props?.currentAppointment?.inmateFirstName ?? formData.inmateFirstName} {props?.currentAppointment?.inmateLastName ?? formData.inmateLastName}
                        </Typography>
                        <Typography variant="overline">
                          DOB: {(() => {
                            const [year, month, day] = (props?.currentAppointment?.inmatedob ?? formData.inmatedob).split("-");
                            return `${month}/${day}/${year}`;
                          })()}&nbsp;
                          | Zip Code: {props?.currentAppointment?.zipCode ?? formData.zipCode}
                        </Typography>
                      </>
                    }
                  />
                </Box>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  px={2}
                >
                  <Typography variant="body1">OR</Typography>
                </Box>
                <Box display="flex" flexDirection="column">
                  <Typography variant="body1" gutterBottom>
                    Select Existing Inmate
                  </Typography>
                  {props.formData.patientMatches.map((patient: PatientInfoResponse) => (
                    <FormControlLabel
                      key={patient.localPatientId}
                      value={patient.localPatientId}
                      control={<Radio />}
                      sx={{
                        p: "5px",
                        my: "5px",
                        border: 1,
                        borderRadius: 2,
                        borderColor: selectedPatientId === patient.localPatientId ? 'primary.main' : 'transparent',
                        transition: 'border-color 0.3s ease',
                        '&:hover': {
                          borderColor: selectedPatientId === patient.localPatientId ? 'primary.main' : 'gray',
                        },
                      }}
                      label={
                        <>
                          <Typography variant="subtitle2">
                            {`${patient.firstName} ${patient.lastName}`}
                          </Typography>
                          <Typography variant="overline">
                            {`DOB: ${patient.dob} | Zip Code: ${patient.zip}`}
                          </Typography>
                        </>
                      }
                    />
                  ))}
                </Box>
              </Box>
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button color="primary" variant="contained" onClick={() => setIsVerifyInmateOpen(false)}>Continue</Button>
        </DialogActions>
      </Dialog>
      <form onSubmit={onSubmit} className="add-patient-form">
        <div className="d-flex justify-content-center">
          <Card
            style={{
              width: '100%',
              maxHeight: 'calc(100vh - 113px)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Card.Body style={{ flex:1, overflowY: 'auto' }}>
              <Card.Title>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Box>
                      <img alt="" src={cofirmappointmentlogo} style={{ height: 32, width: 32 }} />
                    </Box>
                    <Typography variant="h6" component="h2" sx={{ fontWeight: "bold" }}>
                      Confirm { !props?.isReschedule ? "Appointment" : "Reschedule" }
                    </Typography>
                  </Stack>
                </Box>
              </Card.Title>
              <Box display="flex" gap={1} flexDirection="column" justifyContent="space-between" alignItems="center" width="100%">
                { user.getFacilities().length > 1 && (
                  <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" paddingX="30%">
                    <Typography variant="body1">
                      <strong>Facility:</strong>
                    </Typography>
                    <Typography variant="body1">
                      {formData.facilityName}
                    </Typography>
                  </Stack>
                )}
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" paddingX="30%">
                  <Typography variant="body1">
                    <strong>Appointment type:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {formData.appointmenttypename}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" paddingX="30%">
                  <Typography variant="body1">
                    <strong>Provider:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {formData.providername}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                  <Typography variant="body1">
                    <strong>Date:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {formatDate(formData.appointmentDate)} @ {props.convertedTime}
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                  <Typography variant="body1">
                    <strong>Inmate Name:</strong>
                  </Typography>
                  <Typography variant="body1">
                    {selectedPatient ? selectedPatient.firstName + " " + selectedPatient.lastName : formData.inmateFirstName + " " + formData.inmateLastName}
                    {isPatientMatches &&
                      <Button
                        variant="contained"
                        color="success"
                        sx={{ ml: 1 }}
                        onClick={() => setIsVerifyInmateOpen(true)}
                      >
                        View Matches
                      </Button>
                    }
                  </Typography>
                </Stack>
                {formData.incarceration_date && (
                  <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                    <Typography variant="body1">
                      <strong>Date of Incarceration:</strong>
                    </Typography>
                    <Typography variant="body1">
                      {formatYmd(formData.incarceration_date)}
                    </Typography>
                  </Stack>
                )}
                {formData.anticipated_release_date && (
                  <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                    <Typography variant="body1">
                      <strong>Anticipated Release Date:</strong>
                    </Typography>
                    <Typography variant="body1">
                      {formatYmd(formData.anticipated_release_date)}
                    </Typography>
                  </Stack>
                )}
                {daysIncarcerated !== null && (
                  <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                    <Typography variant="body1">
                      <strong>Days Incarcerated:</strong>
                    </Typography>
                    <Typography variant="body1">
                      {daysIncarcerated}
                    </Typography>
                  </Stack>
                )}
                {formData.heldforanothercounty && (
                  <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                    <>
                      <Typography variant="body1">
                        <strong>Held For:</strong>
                      </Typography>
                      <Typography variant="body1">
                        {formData.countyname}
                      </Typography>
                    </>
                  </Stack>
                )}
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                  {formData.medications !== "" ? (
                    <>
                      <Typography variant="body1">
                        <strong>Medication List:</strong>
                      </Typography>
                      <Typography variant="body1">
                        {formData.medications}
                      </Typography>
                    </>
                  ) : (
                    <Typography variant="body1">
                      <strong>No medications listed.</strong>
                    </Typography>
                  )}
                </Stack>
                <Stack direction="row" spacing={1} width="100%" justifyContent="space-between" alignItems="flex-start" paddingX="30%">
                  {formData.additionalinfo !== "" ? (
                    <>
                      <Typography variant="body1">
                        <strong>Additional Info:</strong>
                      </Typography>
                      <Typography variant="body1">
                        {formData.additionalinfo}
                      </Typography>
                    </>
                  ) : (
                    <Typography variant="body1">
                      <strong>No additional information specified.</strong>
                    </Typography>
                  )}
                </Stack>
              </Box>
            </Card.Body>
            <Card.Footer className="text-center d-flex justify-content-center gap-3 flex-wrap">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={6}
                flexWrap="wrap"
              >
                <Button
                  type='button'
                  variant="outlined"
                  sx={{ minWidth: 120 }}
                  onClick={() => {
                    handlePrevious();
                  }}
                >
                  {BUTTONS.PREVIOUS}
                </Button>
                  <Button 
                    type='submit' 
                    variant="contained"
                    sx={{ minWidth: 120 }}
                  >
                    Confirm
                  </Button>
              </Box>
            </Card.Footer>
          </Card >
        </div >
      </form >
    </>
  );
};

export default ConfirmAppointmentForm;
